import { action, onConnect } from '@reatom/framework'

import { reatomRequest } from '@root/shared/lib'

import * as Api from '../api'

export const getAppVersionAction = action(
  Api.getAppVersion,
  'getAppVersionAction',
)

export const appVersionStateAtom = reatomRequest({
  execAction: getAppVersionAction,
  // eslint-disable-next-line @reatom/unit-naming-rule
  name: 'getAppVersionStateAtom',
})

onConnect(appVersionStateAtom, async (ctx) => {
  appVersionStateAtom.execute(ctx)
})
